export default __webpack_public_path__ + "static/media/img3.d8189c82.png";